import { render } from "./BHCheckbox.vue?vue&type=template&id=3cf0ed69&scoped=true&lang=pug"
import script from "./BHCheckbox.vue?vue&type=script&lang=js"
export * from "./BHCheckbox.vue?vue&type=script&lang=js"

import "./BHCheckbox.vue?vue&type=style&index=0&id=3cf0ed69&scoped=true&lang=css"

import exportComponent from "/Users/juvicmartires/Documents/BreakingHits/breakinghits-vuejs-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3cf0ed69"]])

export default __exports__